import { AppThunk } from '../../../store/rootReducer';
import * as beatsActions from '../../beats/beats.actions';
import { togglePinnedBeat } from './toggle-pinned-beat.thunk';

export const cleanBeats = (): AppThunk => async (dispatch) => {
  dispatch(beatsActions.select({ ids: new Set() }));
  dispatch(togglePinnedBeat());
  dispatch(beatsActions.toggleHoveredBeat({}));
};
